export const CAMPAIGN_DELIVERY_OPTIONS = [
  {
    value: "scheduled",
    title: "Scheduled",
    description: "Pick a date and time to send the campaign.",
  },
  {
    value: "sendNow",
    title: "Send Now",
    description: "Delivers as soon as you create the campaign.",
  },
  {
    value: "onDemand",
    title: "On Demand",
    description: "Add to the campaign list and send when you're ready.",
  },
];

export const CAMPAIGN_AUDIENCE_OPTIONS = [
  {
    value: "all",
    title: "Everyone",
    description: "All parents in this institution.",
    extended: false,
  },
  {
    value: "schedule",
    title: "Scheduled trips",
    description: "Parents of students on selected scheduled trips.",
    extended: false,
  },
  {
    value: "tripType",
    title: "Trip type",
    description: "Parents of students on AM, PM, ECA, or other trip types.",
    extended: true,
  },
  {
    value: "family",
    title: "Family",
    description: "Choose one or more families.",
    extended: true,
  },
  {
    value: "stop",
    title: "Stop",
    description: "Choose one or more stops.",
    extended: true,
  },
  {
    value: "campus",
    title: "Campus",
    description: "Parents of students in the primary or secondary campus.",
    extended: true,
  },
];

export const CAMPAIGN_CAMPUS_GRADE_OPTIONS = [
  { value: "primary", label: "Primary" },
  { value: "secondary", label: "Secondary" },
];

export const getVisibleAudienceOptions = (extendedEnabled) =>
  CAMPAIGN_AUDIENCE_OPTIONS.filter(
    (option) => !option.extended || extendedEnabled,
  );
